import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ExecutiveTab from './tabs/ExecutiveTab';
import DetailedTab from './tabs/DetailedTab';


const InsightsTabs = [
    { name: 'Executive Dashboard', value: 'executive', element: ExecutiveTab },
    { name: 'Detailed View', value: 'detailed', element: DetailedTab },
]

const Homepage = () => {
    const navigate = useNavigate()
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const tab = queryParams.get('tab');
    const [activeTab, setActiveTab] = useState<any>(tab ? InsightsTabs?.find((item: any) => item?.value === tab) : InsightsTabs?.[0]);

    const onClickTab = (tab: any) => {
        setActiveTab(tab)
        const params = new URLSearchParams(search);
        params.set('tab', tab?.value);
        navigate({ search: params.toString() }, { replace: true });
    }

	const ActiveElement = activeTab?.element;

    return (
        <div>
            <div className='bg-white dark:bg-bgColor-darkMode'>
                <div className='flex flex-row justify-start'>
                    <div className='my-5 rounded-xl md:rounded-full w-full md:w-auto bg-[#00330F] dark:bg-black flex flex-col md:flex-row items-center px-2 py-2 md:px-1 md:py-1'>
                        {(InsightsTabs)?.map((item: any, idx: number) => {
                            return (
                                <div
                                    key={idx}
                                    onClick={() => onClickTab(item)}
                                    className={`px-3 py-1 cursor-pointer w-[99%] md:w-auto m-auto text-center md:mb-0 hover:opacity-90 ${activeTab?.name === item?.name ? 'bg-white dark:bg-[#00330F] text-black dark:text-white rounded-lg md:rounded-full' : 'text-white dark:text-gray-400'} ${idx === 0 ? 'md:mr-2' : ''} ${idx === InsightsTabs.length - 1 ? 'mb-0' : 'mb-2'}`}>
                                    <p>{item?.name}</p>
                                </div>
                            )
                        })}
                    </div>
                </div>
				{ActiveElement && <ActiveElement changeTab={onClickTab} />}

            </div>
        </div>
    )
}
export default Homepage;